export default __webpack_public_path__ + "static/media/Standard26.55fb295b.png";